import { env } from '@/config/env';

export const openBrainGym = (roomId: string) => {
  if (!roomId) return;
  window.open(
    `${env.OLD_APP_URL}/quiz/practice/${roomId}?accessedBy=streamPlayer`,
    '_blank'
  );
};

export const openAssessment = (assessmentId: string) => {
  if (!assessmentId) return;
  window.open(
    `${env.OLD_APP_URL}/assessment/v3/${assessmentId}/practice?accessedBy=streamPlayer`,
    '_blank'
  );
};

// dummy commit
